import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export default defineMessages({
	header: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-permissions.header',
		defaultMessage: "You can't access any projects or issues",
		description:
			'Header of error message when a user does not have permissions to access a project',
	},
	instructionsAdmin: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-permissions.instructions-admin',
		defaultMessage:
			"You don't have the sufficient permissions. The permission can be changed in the project's permission scheme.",
		description: 'Error message description for restricted access',
	},
	instructionsUser: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-permissions.instructions-user',
		defaultMessage:
			"Try logging in. If you're already logged in, ask a Jira admin to change your permissions.",
		description: 'Instructions for the user on how to obtain access',
	},
	buttonAdmin: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-permissions.button-admin',
		defaultMessage: 'Open permission schemes',
		description: 'Button to open the permission schemes, call to action',
	},
	buttonUser: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-permissions.button-user',
		defaultMessage: 'Contact administrators',
		description: 'Button to contact administrators, call to action',
	},
	headerIssueTermRefresh: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-permissions.header-issue-term-refresh',
		defaultMessage: "You can't access any projects or work items",
		description:
			'Header of error message when a user does not have permissions to access a project',
	},
}) as {
	buttonUser: MessageDescriptor;
	buttonAdmin: MessageDescriptor;
	instructionsUser: MessageDescriptor;
	instructionsAdmin: MessageDescriptor;
	header: MessageDescriptor;
	headerIssueTermRefresh: MessageDescriptor;
};
